/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BridgeComponentMaterial } from './bridgeComponentMaterial';


/**
 * Components of a bridge
 */
export interface BridgeComponent { 
    /**
     * Internal ID
     */
    id?: number;
    /**
     * Internal bridge ID
     */
    bridgeId: number;
    /**
     * Component type
     */
    componentType?: number;
    /**
     * Section ID
     */
    sectionId?: number;
    /**
     * Contains numeric properties about a bridge component
     */
    numericProperties?: string;
    /**
     * Contains category information about a bridge component
     */
    categories?: string;
    /**
     * Contains extra text information about a bridge component
     */
    textProperties?: string;
    bridgeComponentMaterials?: Array<BridgeComponentMaterial>;
}

